export type AssetTagNavigationAction = 'openTagScan' | 'flyToTagIn3D';

interface TagNavigationKnowledgeView {
    ID: string;
    KnowledgeBookID: string;
    Type: number;
}

export const getTagNavigationReturnView = <T extends TagNavigationKnowledgeView>(
    knowledgeBookID: string | null | undefined,
    savedKnowledgeViewID: string | null | undefined,
    knowledgeViews: readonly T[],
): T | undefined => knowledgeBookID && savedKnowledgeViewID
    ? knowledgeViews.find(view => view.ID === savedKnowledgeViewID
        && view.KnowledgeBookID === knowledgeBookID && view.Type === 2)
    : undefined;

interface NavigableTag {
    View360ID?: string;
    Target3D?: { X: number; Y: number; Z: number };
}

export const getPanoTagNavigationActions = (
    tag: NavigableTag | null | undefined,
    contentTypes: readonly string[],
): AssetTagNavigationAction[] => {
    if (!tag?.View360ID) return [];

    const actions: AssetTagNavigationAction[] = ['openTagScan'];
    const has3DContent = contentTypes.some(type =>
        ['Assets', 'CAD Data', 'Point Cloud Data', 'Mesh Data'].includes(type));
    const target = tag.Target3D;
    if (has3DContent && target && [target.X, target.Y, target.Z].every(Number.isFinite)) {
        actions.push('flyToTagIn3D');
    }
    return actions;
};
